import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import FreelancerCommentItem from "./FreelancerCommentItem";
import { tokens } from "../../store/tokens";



const fadeInUp = {
  "@keyframes fadeInUp": {
    from: { opacity: 0, transform: "translateY(16px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
};

const FreelancerComment = ({ id }) => {
  const [freelancerCommentData, setFreelancerCommentData] = useState([]);

  useEffect(() => {
    fetch(
      `https://aps.songjukti.com/profile/login/api_webland/cat_freelancer.php?eid=${id}`
    )
      .then((res) => res.json())
      .then((result) => setFreelancerCommentData(result || []))
      .catch((error) => console.log("listInfoData Error => ", error));
  }, [id]);

  if (freelancerCommentData.length === 0) return null;

  return (
    <Box sx={{ py: { xs: 4, md: 6 } }}>
      <Typography
      
        sx={{
          fontFamily: tokens.headingFont,
          fontWeight: 700,
          fontSize: { xs: "18pt", md: "22pt" },
          color: tokens.ink,
          mb: 3,
          ...fadeInUp,
          animation: "fadeInUp 0.5s ease both",
        }}
      >
        Stories from people who found their match
      </Typography>
      <Stack spacing={3}>
        {freelancerCommentData[0] && (
          <Box sx={{ ...fadeInUp, animation: "fadeInUp 0.5s ease 0.1s both" }}>
            <FreelancerCommentItem data={freelancerCommentData[0]} order={0} />
          </Box>
        )}
        {freelancerCommentData[1] && (
          <Box sx={{ ...fadeInUp, animation: "fadeInUp 0.5s ease 0.2s both" }}>
            <FreelancerCommentItem data={freelancerCommentData[1]} order={1} />
          </Box>
        )}
      </Stack>
    </Box>
  );
};

export default FreelancerComment;